@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.onboarding.onboarding_ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.onboarding.onboarding_ui.generated.resources/"

@delegate:ResourceContentHash(-646_068_811)
internal val Res.drawable.chat_bubble_with_flower: DrawableResource by lazy {
      DrawableResource("drawable:chat_bubble_with_flower", setOf(
        ResourceItem(setOf(), "${MD}drawable/chat_bubble_with_flower.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(777_731_110)
internal val Res.drawable.ic_check_16: DrawableResource by lazy {
      DrawableResource("drawable:ic_check_16", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_check_16.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_679_050_633)
internal val Res.drawable.ic_close_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_close_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_close_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_338_889_600)
internal val Res.drawable.ic_plus_16: DrawableResource by lazy {
      DrawableResource("drawable:ic_plus_16", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_plus_16.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_498_595_043)
internal val Res.drawable.img_adjust01: DrawableResource by lazy {
      DrawableResource("drawable:img_adjust01", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_adjust01.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-219_765_222)
internal val Res.drawable.img_adjust02: DrawableResource by lazy {
      DrawableResource("drawable:img_adjust02", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_adjust02.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_239_274_741)
internal val Res.drawable.img_adjust03: DrawableResource by lazy {
      DrawableResource("drawable:img_adjust03", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_adjust03.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_074_649_993)
internal val Res.drawable.img_adjust04: DrawableResource by lazy {
      DrawableResource("drawable:img_adjust04", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_adjust04.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_774_955_208)
internal val Res.drawable.img_adjust05: DrawableResource by lazy {
      DrawableResource("drawable:img_adjust05", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_adjust05.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-976_663_118)
internal val Res.drawable.img_adjust06: DrawableResource by lazy {
      DrawableResource("drawable:img_adjust06", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_adjust06.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(640_881_466)
internal val Res.drawable.medical_shield: DrawableResource by lazy {
      DrawableResource("drawable:medical_shield", setOf(
        ResourceItem(setOf(), "${MD}drawable/medical_shield.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(619_571_298)
internal val Res.drawable.onboarding_heart: DrawableResource by lazy {
      DrawableResource("drawable:onboarding_heart", setOf(
        ResourceItem(setOf(), "${MD}drawable/onboarding_heart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_924_410_691)
internal val Res.drawable.personal_plan_header: DrawableResource by lazy {
      DrawableResource("drawable:personal_plan_header", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/personal_plan_header.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/personal_plan_header.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/personal_plan_header.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("chat_bubble_with_flower", Res.drawable.chat_bubble_with_flower)
  map.put("ic_check_16", Res.drawable.ic_check_16)
  map.put("ic_close_24", Res.drawable.ic_close_24)
  map.put("ic_plus_16", Res.drawable.ic_plus_16)
  map.put("img_adjust01", Res.drawable.img_adjust01)
  map.put("img_adjust02", Res.drawable.img_adjust02)
  map.put("img_adjust03", Res.drawable.img_adjust03)
  map.put("img_adjust04", Res.drawable.img_adjust04)
  map.put("img_adjust05", Res.drawable.img_adjust05)
  map.put("img_adjust06", Res.drawable.img_adjust06)
  map.put("medical_shield", Res.drawable.medical_shield)
  map.put("onboarding_heart", Res.drawable.onboarding_heart)
  map.put("personal_plan_header", Res.drawable.personal_plan_header)
}
